import { render, staticRenderFns } from "./IconArrow.vue?vue&type=template&id=5db3ae6a&"
import script from "./IconArrow.vue?vue&type=script&lang=ts&"
export * from "./IconArrow.vue?vue&type=script&lang=ts&"
import style0 from "./IconArrow.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports